// extracted by mini-css-extract-plugin
export default {"PatternDateWidget":"PatternDateWidget_PatternDateWidget__gB8f9","fromTo":"PatternDateWidget_fromTo__01bCp","danger":"PatternDateWidget_danger__iPQpI"};